(function (w) {
	'use strict';

	/**
	 * @ngdoc type
	 * @name mx.shell.HttpMethod
	 * @module mx.shell
	 *
	 * @description
	 * Codes of http methods
	 */

	function MxHttpMethod() {
		this.None = 0;
		this.Get = 1;
		this.Post = 2;
		this.Put = 3;
		this.Delete = 4;
	}

	/**
	 * @ngdoc type
	 * @name mx.shell.HttpMethod#find
	 * @module mx.shell
	 *
	 * @param {string|number} value - name or value of http method
	 * @description
	 * Get http method code by name or valuemx.shell.ObjectPropertyType
	 *
	 */
	MxHttpMethod.prototype.find = function (value) {
		var self = this;

		if (typeof value === 'number') {
			return value;
		} else if (typeof value === 'string' && value.length === 1) {
			return Number(value);
		}

		value = (value || '').toUpperCase();
		switch (value) {
			case 'GET':
				return self.Get;

			case 'POST':
				return self.Post;

			case 'PUT':
				return self.Put;

			case 'DELETE':
				return self.Delete;

			default:
				return self.None;
		}
	};

	w.mx = w.mx || {};
	w.mx.shell = w.mx.shell || {};
	w.mx.shell.HttpMethod = new MxHttpMethod();
})(window);
